import { App } from "vue";
import ltAModel from "./components/lt-a-model";
import ltAFrame from "./components/lt-frame";
import ltSplitPanel from "./components/lt-split-panel"; //可拖动分隔符
import ltATable from "./components/lt-a-table";
import ltAForm from "./components/lt-a-form";
import ltStaticText from "./components/lt-a-text"
import loading from "./components/directives/loading/index";
import ltAPopover from "./components/lt-a-popover";
import ltADrawer from "./components/lt-a-drawer";
import ltAPopconfirm from "./components/lt-a-popconfirm";
import ltATooltip from "./components/lt-a-tooltip";
import ltMonitor from "./components/lt-monitor";

const components = [ltStaticText, ltAModel, ltAFrame, ltSplitPanel, ltATable, ltAForm, ltAPopover, ltADrawer, ltAPopconfirm, ltATooltip, ltMonitor];

const install = (app: App) => {
  components.forEach((component) => {
    //@ts-ignore
    app.component(component.name, component);
  });
  app.use(loading)
};

export default {
  install,
  ltAModel,
  ltAFrame,
  ltSplitPanel,
  ltATable,
  ltAForm,
  ltStaticText,
  loading,
  ltAPopover,
  ltADrawer,
  ltAPopconfirm,
  ltATooltip,
  ltMonitor
};
